import { TrackingStatusAnalyticsActionTypes } from './constants';

export const INIT_STATE = {
    errorGetTrackingNoShipments: null,
    loadingTrackingNoShipments: false,
    trackingNoShipments: null,
    errorGetTrackingNoShipmentsWithTrackingEvents: null,
    loadingTrackingNoShipmentsWithTrackingEvents: false,
    trackingNoShipmentsWithTrackingEvents: null,
    errorGetTrackingNoDelivered: null,
    loadingTrackingNoDelivered: false,
    trackingNoDelivered: null,
    errorGetTrackingNoUndelivered: null,
    loadingTrackingNoUndelivered: false,
    trackingNoUndelivered: null,
    errorGetTrackingNoExceptions: null,
    loadingTrackingNoExceptions: false,
    trackingNoExceptions: null,
    errorGetTrackingStatus: null,
    loadingTrackingStatus: false,
    trackingStatus: null,
    errorGetTrackingStatusByTimeframe: null,
    loadingTrackingStatusByTimeframe: false,
    trackingStatusByTimeframe: null,
    errorGetTrackingStatusSummary: null,
    loadingTrackingStatusSummary: false,
    trackingStatusSummary: null,
};

type TrackingStatusAnalyticsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetTrackingNoShipments?: null,
    loadingTrackingNoShipments: Boolean,
    trackingNoShipments: any,
    errorGetTrackingNoShipmentsWithTrackingEvents?: null,
    loadingTrackingNoShipmentsWithTrackingEvents: Boolean,
    trackingNoShipmentsWithTrackingEvents: any,
    errorGetTrackingNoUndelivered?: null,
    loadingTrackingNoUndelivered: Boolean,
    trackingNoUndelivered: any,
    errorGetTrackingNoExceptions: null,
    loadingTrackingNoExceptions: Boolean,
    trackingNoExceptions: any,
    errorGetTrackingStatus: null,
    loadingTrackingStatus: Boolean,
    trackingStatus: any,
    errorGetTrackingStatusByTimeframe: null,
    loadingTrackingStatusByTimeframe: Boolean,
    trackingStatusByTimeframe: any,
    errorGetTrackingStatusSummary: null,
    loadingTrackingStatusSummary: Boolean,
    trackingStatusSummary: any,
};

const TrackingStatusAnalytics = (state: State = INIT_STATE, action: TrackingStatusAnalyticsAction): any => {
    switch (action.type) {
        case TrackingStatusAnalyticsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS: {
                    return { ...state, loadingTrackingNoShipments: false, trackingNoShipments: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS: {
                    return { ...state, loadingTrackingNoShipmentsWithTrackingEvents: false, trackingNoShipmentsWithTrackingEvents: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED: {
                    return { ...state, loadingTrackingNoDelivered: false, trackingNoDelivered: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED: {
                    return { ...state, loadingTrackingNoUndelivered: false, trackingNoUndelivered: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS: {
                    return { ...state, loadingTrackingNoExceptions: false, trackingNoExceptions: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS: {
                    return { ...state, loadingTrackingStatus: false, trackingStatus: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME: {
                    return { ...state, loadingTrackingStatusByTimeframe: false, trackingStatusByTimeframe: action.payload.data };
                }
                case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY: {
                    return { ...state, loadingTrackingStatusSummary: false, trackingStatusSummary: action.payload.data };
                }
                default:
                    return { ...state, loadingTrackingNoShipments: false, loadingTrackingNoShipmentsWithTrackingEvents: false, loadingTrackingNoDelivered: false, loadingTrackingNoUndelivered: false, loadingTrackingNoExceptions: false, loadingTrackingStatus: false, trackingStatus: null, loadingTrackingStatusByTimeframe: false, trackingStatusByTimeframe: null, loadingTrackingStatusSummary: false, trackingStatusSummary: null };
            }

        case TrackingStatusAnalyticsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS: {
                    return { ...state, loadingTrackingNoShipments: false, errorGetTrackingNoShipments: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS: {
                    return { ...state, loadingTrackingNoShipmentsWithTrackingEvents: false, errorGetTrackingNoShipmentsWithTrackingEvents: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED: {
                    return { ...state, loadingTrackingNoDelivered: false, errorGetTrackingNoDelivered: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED: {
                    return { ...state, loadingTrackingNoUndelivered: false, errorGetTrackingNoUndelivered: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS: {
                    return { ...state, loadingTrackingNoExceptions: false, errorGetTrackingNoExceptions: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS: {
                    return { ...state, loadingTrackingStatus: false, errorGetTrackingStatus: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME: {
                    return { ...state, loadingTrackingStatusByTimeframe: false, errorGetTrackingStatusByTimeframe: action.payload.error };
                }
                case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY: {
                    return { ...state, loadingTrackingStatusSummary: false, errorGetTrackingStatusSummary: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS:
            return { ...state, loadingTrackingNoShipments: true, trackingNoShipments: null };
        case TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS:
            return { ...state, loadingTrackingNoShipmentsWithTrackingEvents: true, trackingNoShipmentsWithTrackingEvents: null };
        case TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED:
            return { ...state, loadingTrackingNoDelivered: true, trackingNoDelivered: null };
        case TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED:
            return { ...state, loadingTrackingNoUndelivered: true, trackingNoUndelivered: null };
        case TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS:
            return { ...state, loadingTrackingNoExceptions: true, trackingNoExceptions: null };
        case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS:
            return { ...state, loadingTrackingStatus: true, trackingStatus: null };
        case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME:
            return { ...state, loadingTrackingStatusByTimeframe: true, trackingStatusByTimeframe: null };
        case TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY:
            return { ...state, loadingTrackingStatusSummary: true, trackingStatusSummary: null };
        default:
            return { ...state };
    }
};

export default TrackingStatusAnalytics;